/* HRS mobile sticky ATC show/hide - ported from live theme.min.js (165983453422) */
(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;

  document.documentElement.classList.add('hrs-mobile-buybar-runtime');

  function initMobileBuybar() {
    var bar = document.querySelector('[data-hrs-mobile-buybar]');
    if (!bar) return false;
    if (window.__hrsMobileBuybarElement === bar) return true;

    window.__hrsMobileBuybarElement = bar;
    window.__hrsMobileBuybarReady = true;
    document.documentElement.classList.add('hrs-mobile-buybar-ready');

  var stickyButton = bar.querySelector('[data-hrs-mobile-submit]');
    var stickyPrice = bar.querySelector('[data-hrs-mobile-price]');
    var updateFrame;
    var contentObserver;
  
    function mainButton() {
      return document.querySelector('#MainContent button.product--add-to-cart-button[name="add"]') ||
        document.querySelector('#MainContent button[name="add"][type="submit"]');
    }
  
    function priceElement() {
      return document.querySelector('#MainContent [data-product-price]');
    }
  
    function mainButtonLabel(button) {
      var label = button ? button.querySelector('[data-add-to-cart-text]') : null;
      return label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
    }
  
    function syncContent() {
      var button = mainButton();
      var price = priceElement();
  
      if (price && stickyPrice) {
        stickyPrice.textContent = price.textContent.replace(/\s+/g, ' ').trim();
      }
  
      if (button && stickyButton) {
        var label = mainButtonLabel(button);
        if (label) stickyButton.textContent = label;
        stickyButton.disabled = Boolean(button.disabled);
        stickyButton.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      }
    }
  
    function updateVisibility() {
      updateFrame = null;
      var button = mainButton();
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var show = false;
  
      if (button && isMobile) {
        var buttonRect = button.getBoundingClientRect();
        show = buttonRect.bottom < 0;
      }
  
      bar.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('hrs-mobile-buybar-on', show);
      syncContent();
    }
  
    function queueUpdate() {
      if (updateFrame) return;
      updateFrame = window.requestAnimationFrame(updateVisibility);
    }
  
    function observePurchaseArea() {
      if (contentObserver) contentObserver.disconnect();
  
      var button = mainButton();
      var price = priceElement();
      if (!button && !price) return;
  
      contentObserver = new MutationObserver(queueUpdate);
  
      if (button) {
        contentObserver.observe(button, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
          attributeFilter: ['disabled', 'class', 'style']
        });
      }
  
      if (price && price !== button) {
        contentObserver.observe(price, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
          attributeFilter: ['class', 'style']
        });
      }
    }
  
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var button = mainButton();
        if (!button) return;
  
        if (button.disabled) {
          button.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
  
        button.click();
      });
    }
  
    document.addEventListener('change', function () {
      window.setTimeout(function () {
        observePurchaseArea();
        queueUpdate();
      }, 50);
    });
  
    document.addEventListener('shopify:section:load', function () {
      observePurchaseArea();
      queueUpdate();
    });
  
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate, { passive: true });
  
    observePurchaseArea();
    updateVisibility();

    return true;
  }

  if (initMobileBuybar()) return;

  var bootObserver = new MutationObserver(function () {
    if (initMobileBuybar()) bootObserver.disconnect();
  });

  bootObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', initMobileBuybar, { once: true });
})();
